export const convertToDecimalString = (value) => {
  if (/\s/g.test(value)) {
    value = value.replace(/\s/g, "");
  }
  var last = String(value).lastIndexOf(",");
  if (last > -1) {
    var val =
      value.substring(0, last) + "." + value.substring(last + 1, value.length);
  } else {
    val = value + ".00";
  }
  return val;
};

export const convertToDecimalForPoreznaString = (value) => {
  console.log("tutu:", value);
  if (/\s/g.test(value)) {
    value = value.replace(/\s/g, "");
  }

  let formattedNumber = value.toFixed(2);
  console.log(formattedNumber); 
  console.log("val",formattedNumber.toString());
  var last = String(value).lastIndexOf(".");
  if (last > -1) {
    var val = value.toString();
  } else {
    console.log("tutu");
    val = value + ".00";
  }
  return formattedNumber;
};
